module.exports = __webpack_public_path__ + "img/sloth.8976d952.png";